<template>
  <l-layout layout="xs12 sm10 md8">
    <l-data-table
      hide-actions
      hide-title
      hide-headers
      :headers="[{text: '区域名称', value: 'name'}]"
      :must-sort="false"
      :items="areaList"
    ></l-data-table>
  </l-layout>
</template>

<script>
export default {
  name: 'list',
  computed: {
    areaList () {
      return this.$store.state.violation.areaList.map(v => ({id: v, name: v}))
    }
  },
  created () {
    this.$store.dispatch('violation/getArea')
  }
}
</script>

<style scoped>

</style>
